import type { Question } from '@mentimeter/http-clients';
import useSWR from 'swr';
import { getIdentifiedResultsCacheKey } from '@mentimeter/core-hooks';
import {
  getIdentifiedTextResponsesRequest,
  getIdentifiedTextResponsesResponse,
} from '@core-api/presentation/presentation/questions/{admin_key}/identified-text-responses';
import { makeRequest } from '../../request-wrapper/make-request';

export const useIdentifiedTextResponses = (
  adminKey: Question['admin_key'],
  shouldFetch = true,
) => {
  return useSWR(
    shouldFetch ? getIdentifiedResultsCacheKey(adminKey) : null,
    async () => {
      const data = await fetch(
        makeRequest(getIdentifiedTextResponsesRequest, { adminKey }),
      );
      return await getIdentifiedTextResponsesResponse(data, {
        enableStatusCheck: true,
      });
    },
    { shouldRetryOnError: false },
  );
};
